import { toast } from "@overmap-ai/blocks"

import { LoadingIndicatorToast } from "./LoadingIndicatorToast"
import { ProgressIndicatorToast } from "./ProgressIndicatorToast"

interface ProgressToastConfig {
	id?: string | number
	progress: number
	description?: string
}

export const progressToast = (config: ProgressToastConfig) => {
	const { id, progress, description } = config
	return toast.custom(() => <ProgressIndicatorToast progress={progress} description={description} />, {
		id,
		dismissible: false,
		duration: Infinity,
	})
}

interface LoadingToastConfig {
	id?: string | number
	description?: string
}

export const loadingToast = (config: LoadingToastConfig) => {
	const { id, description } = config
	return toast.custom(() => <LoadingIndicatorToast description={description} />, {
		id,
		dismissible: false,
		duration: Infinity,
	})
}
